<style scoped>
.book_banner_inner {
  font-size: 5.71rem !important
}
.front_img{
  top:.16rem !important;
  right:.22rem !important;
  width:5.71rem !important;
  height:8.12rem !important
}
.mod_poster_list .banner_front .front_mask_top {
    left: -0.09rem !important;
    width: 3.28rem !important;
}
.mod_poster_list .book_banner {
    width: 6.78rem !important;
    height: 8.56rem !important;
}
.mod_poster_list .book_detail,.mod_poster_list .book_btn{
  padding: 0 .94rem !important
}
.mod_poster_list .book_banner .right_img{
  top: 1.53rem !important;
  left: 1.21rem !important;
  width: 5.02rem !important;
  height: 5.02rem !important;
}
.mod_poster_list .book_banner .right_img:before{
  width: 0.942rem !important;
  height: 0.942rem !important;
}
.mod_poster_list .book_banner .right_img:after{
  width: 4.38rem !important;
  height: 1.256rem !important;
  left: 0.314rem !important;
}
.mod_poster_list .book_banner .btn_disconnect{
  right: -0.47rem !important;
  bottom: 1.63rem !important;
  width: 1.63rem !important;
  height: 1.63rem !important;
}
.mod_poster_list .book_banner .btn_disconnect .txt{
  font-size: 0.41rem !important;
  line-height: 1.63rem !important;
}
.mod_poster_list .book_banner .icon_stamp{
  display: inline;
  right: -2.51rem !important;
  bottom: .942rem !important;
  width: 5.02rem !important;
  height: 5.02rem !important;
}
</style>
<template>
  <!--拆开 加ani_open -->
        <div class="mod_poster_list" :class="cover.posterOpenClass">
            <div class="poster_list">
                <div class="book_banner">
                    <div class="book_banner_inner">
                        <div class="banner_left">
                            <div class="banner_front">
                                <div class="front_img"><img :src="cover.pic"></div>
                                <div class="front_mask">
                                    <div class="front_mask_top"></div>
                                </div>
                            </div>
                            <div v-if="isTakeUser" class="banner_back"></div>
                        </div>
                        <div v-if="isTakeUser" class="banner_right">
                            <div class="right_img">
                                <span class="img" :style="`background-image:url(${cover.pic})`"></span>
                            </div>
                        </div>
                    </div>
                    <a v-if="isTakeUser && showDisconnectBtn" class="btn_disconnect" @click="takeOption">
                        <span class="dot dot_1"></span>
                        <span class="dot dot_2"></span>
                        <span class="txt">拆礼物</span>
                    </a>
                    <span v-if="isTakeUser && cover && cover.iconStamp" class="icon_stamp" :class="cover.iconStamp">已抢完</span>
                </div>
                <div class="book_detail">
                    <div class="detail_inner">
                        <div class="detail_txt">
                            <span class="quote quote_l">“</span>
                            <span class="txt">{{cover.desc}}</span>
                            <span class="quote quote_r">”</span>
                        </div>
                    </div>
                    <a v-if="!isTakeUser && showSendBtn" class="btn_give" @click="sendOption">赠送影片给好友</a>
                </div>
                <div v-if="isTakeUser" class="book_btn">
                    <a v-if="showOpenApp" class="btn_a" @click="openApp">{{`${isAppInstalled ? '打开' : '下载'}腾讯视频观看影片`}}</a>
                    <a v-if="showPayBtn && payVipInfo && !payVipInfo.vip && !isApp()" class="btn_b" @click="goToPay">开VIP，我也要送</a>
                    <a v-if="showSendBackBtn && !isApp() && payVipInfo && payVipInfo.vip" class="btn_b" @click="openMore">回赠好友，去选片</a>
                </div>
            </div>
        </div>

</template>

<script>
import login from '@tencent/vft-common/login'
import cookie from '@tencent/vft-common/cookie'
import env from '@tencent/vft-common/env'
import openApp from '@tencent/vft-common/openapp'
import { checkPay, queryTicket, useTicket } from '../service/ticket'
import { showShareButton } from '../util/share'

export default {
  props: ['showOpenAppBtn', 'showPayBtn', 'cover', 'showDisconnectBtn', 'showSendBackBtn', 'showSendBtn', 'user'],
  data () {
    return {
      isAppInstalled: true
    }
  },
  async created () {
    if (openApp.canGetInstallState) {
      if (await openApp.getInstallState()) {
        this.isAppInstalled = true
      } else {
        this.isAppInstalled = false
      }
    }
  },
  methods: {
    getAPPAuthParam (callback) {
      var param = '&isSpecial=1'
      if (login.isLogin()) {
        if (login.loginType() === 'wx') {
          login.getMainUserInfo().then((info) => {
            if (info) {
              var vuserid = cookie.get('vuserid')
              param += ['&userid=', vuserid, '&nickname=', encodeURIComponent(info.nick), '&userType=wx&needAuthorize=1'].join('')
            }
            param += '&textType=1'
            callback && callback(param)
          })
        } else {
          var uin = login.getUin()
          param += ['&userid=', uin, '&userType=qq&needAuthorize=1'].join('')
          param += '&textType=1'
          callback && callback(param)
        }
      } else {
        callback && callback(param)
      }
    },
    async openApp (authparam) {
      this.getAPPAuthParam(async (param) => {
        param = param || ''
        var callback = ''
        if (env.isWechat) {
          callback = '&callback=weixin%3A%2F%2F&sender=%e5%be%ae%e4%bf%a1&jumpaction=1000'
        }
        var cid = this.cover.cid // 专辑ID
        var targetOpenUrl = ['tenvideo2://?action=1&cover_id=', cid, param, callback].join('')
        if (env.isIpad) {
          targetOpenUrl = ['tenvideo2://?action=1&cover_id=', cid, param, callback].join('')
        }
        targetOpenUrl += '&nickname=' + encodeURIComponent(this.userInfo.nick)
        if (!this.isAppInstalled) {
          openApp.download()
        }

        if (await openApp.launch(targetOpenUrl)) {
          // 有安装
        } else {
          // 无安装
          openApp.download()
        }
      })
    },
    takeOption () {
      if (login.isLogin()) {
        return this.$emit('take')
      }
      cookie.set('givemovie_take', '1', {
        domain: location.host,
        path: '/'
      })
      this.$openLogin()
    },
    async sendOption () {
      let that = this
      if (!env.isWechat && !env.isMqq && !env.isApp) {
        return this.alert('请在腾讯视频APP、微信、手机QQ中赠送影片')
      }
      try {
        let payResult = await checkPay(this.cid)
        if (!payResult) {
          if (this.cover.paystatus === 4) {
            var coverValidDate = this.cover.pay_last_valid_date
            this.useTicketAndGive(coverValidDate)
            return
          }
          return this.alert({
            msg: '您当前没有赠片资格，开腾讯视频VIP获取赠片资格',
            confirm () {
              that.goToPay()
            }
          })
        }
        if (this.cover.taskInfo && this.cover.taskInfo.tid) { // 用户赠送过该片
          return this.$emit('showShare')
        }
        if (!this.user.activenum) { // 用户没有赠片资格且没有赠送过该片
          return this.alert({
            msg: '您当前没有赠片资格，开腾讯视频VIP获取赠片资格',
            confirm () {
              that.goToPay()
            }
          })
        }
        showShareButton()
        this.$emit('showShare')
        this.$emit('buildShare')
      } catch (ex) {
        this.alert({
          msg: '请求失败，请稍候再试',
          confirm () {
            location.reload()
          }
        })
      }
    },
    async useTicketAndGive (coverValidDate) {
      let that = this
      // 先查券
      try {
        let query = await queryTicket()
        if (query.result.code === 0) {
          var notUseNum = query.not_use
          if (notUseNum > 0) {
            var tmpValidDate = ''
            if (coverValidDate) {
              tmpValidDate = '，观影有效期至' + coverValidDate
            }
            this.confirm({
              title: '使用观影券后才可赠送',
              msg: '剩余观影券' + parseInt(notUseNum) + '张，本次消耗1张' + tmpValidDate,
              confirmText: '用券并赠送',
              cancelText: '以后再说',
              confirm () {
                // 用券需验强登录
                login.isStrictLogin((isStrictLogin) => {
                  if (isStrictLogin) {
                    // 用券并赠送
                    useTicket(that.cover).then(function () {
                      // 展示分享按钮
                      showShareButton()
                      // 设置分享信息
                      that.$emit('buildShare')
                      // 展示分享浮层
                      that.$emit('showShare')
                    }).catch(function () {
                      // 用券失败
                      that.alert('用券失败，请再次尝试')
                    })
                  } else {
                    that.$openLogin()
                  }
                })
              }
            })
          } else {
            this.confirm({
              title: '使用观影券后才可赠送',
              msg: '剩余观影券0张，续费会员立即获赠2张观影券',
              confirmText: '续费会员',
              cancelText: '以后再说',
              confirm () {
                // 续费获得券，才可赠送
                that.goToPay()
              }
            })
          }
        }
      } catch (ex) {
        // 查询观影券失败
        this.alert({
          msg: '请求失败，请稍候再试（useTicketAndGive）',
          confirm () {
            location.reload()
          }
        })
      }
    }
  },
  computed: {
    showOpenApp () {
      return navigator.userAgent.indexOf('Weibo') === -1 && !env.isApp && this.showOpenAppBtn
    }
  }
}
</script>
